<template>
	<view @click="click(data.config.path)" style="overflow: hidden;"
		:style="{'background':data.config.containerBgColor ||'','border-radius':data.config.borderRadius+'px','color':data.config.textColor ||'','marginTop': data.config.marginTop+'px','marginRight': data.config.marginRight+'px', 'marginBottom': data.config.marginBottom+'px','marginLeft': data.config.marginLeft+'px','paddingTop': data.config.paddingTop+'px','paddingBottom': data.config.paddingBottom+'px','paddingLeft': data.config.paddingLeft+'px','paddingRight': data.config.paddingRight+'px'}">
		<div class="cardContainerItemView" v-bind:style="{background:data.config.cardBgColor ||''}">
			<div><img class="storePicture" :src="shop.avatar" /></div>
			<div class="descContainer">
				<label class="labelItem"
					v-bind:style="{color:data.config.titleColor ||''}">{{shop.name}}</label>
				<label class="labelItem addressLabel" v-bind:style="{color:data.config.addressColor ||''}"><i
						type="ios-navigate-outline" size="18" /> &nbsp;&nbsp;{{shop.address}}</label>
			</div>
		</div>
	</view>
</template>

<script>
	export default {
		name: 'Tpl_Text',
		props: {
			data: {
				type: Object,
				default: () => ({})
			},
			shop: {
				type: Object,
				default: () => ({})
			},
		},
		data() {
			return {
				
			}
		},
		methods: {
			click(path) {
				uni.navigateTo({
					url: path
				});

			},
		}
	};
</script>

<style scoped>
	.cardContainerItemView {
		display: flex;
		background-color: white;
		padding: 0.625rem;
		box-sizing: border-box;
		border-radius: 0.25rem;
		overflow: hidden;
		/* text-align: center; */
	}


	.storePicture {
		height: 5rem;
		width: 5rem;
		background-color: #E8E8E8;
		border-radius: 5rem;
		overflow: hidden;
	}

	.descContainer {
		margin-left: 0.625rem;
		display: flex;
		flex-direction: column;
		justify-content: center;
		height: 5rem;
	}

	.labelItem {
		width: 100%;
		color: rgb(51, 51, 51);
		font-size: 0.9375rem;
	}

	.addressLabel {
		margin-top: 0.625rem;
		font-size: 0.75rem;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}
</style>